import { useAtomValue } from 'jotai';
import { ReactNode } from 'react';

import { zoomLevelAtom } from '../../../store/index.atom';

import * as Styled from './index.styles';

interface Props {
  isMobile?: boolean;
  children: ReactNode;
}

const ZoomableViwer = ({ isMobile = false, children }: Props) => {
  const zoomLevel = useAtomValue(zoomLevelAtom);

  return (
    <Styled.ZoomWrapper>
      <Styled.ViewerContainer zoomLevel={zoomLevel} isMobile={isMobile}>
        {children}
      </Styled.ViewerContainer>
    </Styled.ZoomWrapper>
  );
};

export default ZoomableViwer;
